/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateIcebreakerRequest } from '../models/CreateIcebreakerRequest';
import type { IcebreakerModel } from '../models/IcebreakerModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IcebreakersService {
	/**
	 * Get all icebreakers for this club
	 * GET /clubs/<display id>/icebreakers
	 * @returns IcebreakerModel Successful Response
	 * @throws ApiError
	 */
	public static getIcebreakersClubsDisplayIdIcebreakersGet({
		displayId
	}: {
		/**
		 * The unique Display Id of the associated Intros Club. Obtained from Intros Club Dashboard.
		 */
		displayId: string;
	}): CancelablePromise<Array<IcebreakerModel>> {
		return __request(OpenAPI, {
			method: 'GET',
			url: '/clubs/{displayId}/icebreakers',
			path: {
				displayId: displayId
			},
			errors: {
				422: `Validation Error`
			}
		});
	}

	/**
	 * Create a new icebreaker for this club
	 * POST /clubs/<display id>/icebreakers
	 * @returns any Successful Response
	 * @throws ApiError
	 */
	public static createIcebreakerClubsDisplayIdIcebreakersPost({
		displayId,
		requestBody
	}: {
		/**
		 * The unique Display Id of the associated Intros Club. Obtained from Intros Club Dashboard.
		 */
		displayId: string;
		requestBody: CreateIcebreakerRequest;
	}): CancelablePromise<any> {
		return __request(OpenAPI, {
			method: 'POST',
			url: '/clubs/{displayId}/icebreakers',
			path: {
				displayId: displayId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				422: `Validation Error`
			}
		});
	}

	/**
	 * Delete an icebreaker for this club
	 * POST /clubs/<display id>/icebreakers/id
	 * @returns any Successful Response
	 * @throws ApiError
	 */
	public static deleteIcebreakerClubsDisplayIdIcebreakersIcebreakerIdDelete({
		displayId,
		icebreakerId
	}: {
		/**
		 * The unique Display Id of the associated Intros Club. Obtained from Intros Club Dashboard.
		 */
		displayId: string;
		icebreakerId: number;
	}): CancelablePromise<any> {
		return __request(OpenAPI, {
			method: 'DELETE',
			url: '/clubs/{displayId}/icebreakers/{icebreakerId}',
			path: {
				displayId: displayId,
				icebreakerId: icebreakerId
			},
			errors: {
				422: `Validation Error`
			}
		});
	}
}
